import { render } from "./Mainwechat.vue?vue&type=template&id=76536028&scoped=true"
import script from "./Mainwechat.vue?vue&type=script&lang=js"
export * from "./Mainwechat.vue?vue&type=script&lang=js"

import "./Mainwechat.vue?vue&type=style&index=0&id=76536028&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76536028"]])

export default __exports__